import { render, staticRenderFns } from "./AITrainingTermsPanel.vue?vue&type=template&id=e3778766&scoped=true"
import script from "./AITrainingTermsPanel.vue?vue&type=script&lang=js"
export * from "./AITrainingTermsPanel.vue?vue&type=script&lang=js"
import style0 from "./AITrainingTermsPanel.vue?vue&type=style&index=0&id=e3778766&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3778766",
  null
  
)

export default component.exports